<app-add-form
  data-testid="inbound-add-form"
  #addForm
  [title]="'inbound.pages.add_inbound_warrant' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="loading()"
  (formAction)="onFormAction($event.action)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
>
  <!-- Actions Template for both Detail and Logistics tables -->
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      <!-- Check if this is a detail item (has skuCode) or logistics item (has logisticsCompanyId) -->
      @if (rowData.skuCode) {
        <!-- Detail item actions -->
        <span
          [attr.data-testid]="'inbound-add-action-delete-detail-' + rowData.skuCode"
          (click)="onTableAction({ action: 'deleteDetail', data: rowData })"
          class="action-link action-delete cursor-pointer"
        >
          {{ "inbound.actions.delete" | translate }}
        </span>
      } @else if (rowData.logisticsCompanyId) {
        <!-- Logistics item actions -->
        <span
          [attr.data-testid]="'inbound-add-action-edit-logistics-' + rowData.logisticsCompanyId"
          (click)="onTableAction({ action: 'editLogistics', data: rowData })"
          class="action-link action-edit cursor-pointer"
        >
          {{ "inbound.actions.edit" | translate }}
        </span>
        <span
          [attr.data-testid]="'inbound-add-action-delete-logistics-' + rowData.logisticsCompanyId"
          (click)="onTableAction({ action: 'deleteLogistics', data: rowData })"
          class="action-link action-delete cursor-pointer"
        >
          {{ "inbound.actions.delete" | translate }}
        </span>
      }
    </div>
  </ng-template>
</app-add-form>

<!-- Logistics Dialog -->
<app-logistics-dialog
  data-testid="inbound-add-logistics-dialog"
  [(visible)]="showLogisticsDialog"
  [initialData]="editingLogistics()"
  [editMode]="!!editingLogistics()"
  (confirm)="onLogisticsDialogConfirm($event)"
  (visibleChange)="showLogisticsDialog.set($event)"
></app-logistics-dialog>

<!-- Detail Dialog -->
<app-detail-dialog
  data-testid="inbound-add-detail-dialog"
  [(visible)]="showDetailDialog"
  [existingItems]="detailList()"
  (confirm)="onDetailDialogConfirm($event)"
  (visibleChange)="showDetailDialog.set($event)"
></app-detail-dialog>

<!-- Delete Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'inbound-add-delete-confirmation-dialog'"
  [(visible)]="showDeleteConfirmDialog"
  [title]="getDeleteConfirmTitle()"
  [message]="getDeleteConfirmMessage()"
  [buttons]="getDeleteConfirmButtons()"
  (emitOnClick)="onDeleteConfirmAction($event)"
  (visibleChange)="showDeleteConfirmDialog.set($event)"
></app-confirmation-dialog>

<!-- Toast Messages -->
<p-toast data-testid="inbound-add-toast"></p-toast>
